import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const LogoutIcon = (props: SvgProps) => (
  <Svg width={16} height={16} fill="none" {...props}>
    <Path
      fill="#000"
      d="M1.686 15.923a1.48 1.48 0 0 1-1.089-.445 1.486 1.486 0 0 1-.445-1.093V1.692C.152 1.26.301.895.597.6c.297-.297.66-.445 1.09-.445h6.346v.923H1.691a.588.588 0 0 0-.423.192.588.588 0 0 0-.193.423v12.693c0 .153.065.294.193.423.128.128.269.192.423.192h6.342v.923H1.686Zm10.759-4.49-.659-.645L14.074 8.5H5.237v-.923h8.837l-2.288-2.289.659-.654 3.4 3.4-3.4 3.4Z"
    />
  </Svg>
);
export default LogoutIcon;
